import React from 'react';
import TextTemplateComponent from '../Components/TextTemplate/TextTemplateComponent';

const TextTemplatePage = () => {
    return (
        <div className='' style={{
            marginTop:20,
        }}>
            <TextTemplateComponent />
        </div>
    )
}

export default TextTemplatePage;